// meseci za adrese kalendara dogadjaja (/2026/oktobar/1); en = engleski naziv iz starih linkova (/2026/october/1)
const months = [
    { value: '01', name: 'Januar', en: 'january' },
    { value: '02', name: 'Februar', en: 'february' },
    { value: '03', name: 'Mart', en: 'march' },
    { value: '04', name: 'April', en: 'april' },
    { value: '05', name: 'Maj', en: 'may' },
    { value: '06', name: 'Jun', en: 'june' },
    { value: '07', name: 'Jul', en: 'july' },
    { value: '08', name: 'Avgust', en: 'august' },
    { value: '09', name: 'Septembar', en: 'september' },
    { value: '10', name: 'Oktobar', en: 'october' },
    { value: '11', name: 'Novembar', en: 'november' },
    { value: '12', name: 'Decembar', en: 'december' },
]

/**
 * Mesec iz adrese: srpski naziv, ili engleski (tada redirect = srpski naziv za 301 preusmerenje).
 * @returns {{ month: object, redirect: string|null } | null}
 */
export const findMonthBySlug = (slug) => {
    const key = String(slug ?? '').toLowerCase()
    const sr = months.find((m) => m.name.toLowerCase() === key)
    if (sr) return { month: sr, redirect: null }

    const en = months.find((m) => m.en === key)
    return en ? { month: en, redirect: en.name.toLowerCase() } : null
}

export default { months }
